// Registro di tracciabilità: manda al backend (POST /api/tracciabilita → tabella `tracciabilita`)
// ciò che va ritrovato dopo. Non manda né la data (la mette il database) né l'IP (lo ricava il backend).
// Non blocca e non lancia mai errori: la tracciabilità non deve disturbare l'utente.
import { api } from "../api/client";

const sent = new Set();

// `note` è libero (stringa o oggetto). Con `dedupeKey` la stessa segnalazione parte una sola volta
// per sessione, per non riempire la tabella quando lo stesso errore si ripete.
export async function trace({ user, sezione, azione, note, dedupeKey }) {
  try {
    if (dedupeKey) {
      const key = `${sezione}:${azione}:${user?.id ?? "?"}:${dedupeKey}`;
      if (sent.has(key)) return;
      sent.add(key);
    }
    await api.post("/api/tracciabilita", {
      cliente_id: user?.cliente_id ?? null,
      user_id: user?.id ?? null,
      user_name: user?.username ?? null,
      sezione,
      azione,
      note,
    });
  } catch (_) {
    // ignorato di proposito
  }
}
